import { FileDescriptor } from "cuba/entities/base/sys$FileDescriptor";

export const fileDescriptorNormalize = (
  dataInstanceValue?: FileDescriptor[] | FileDescriptor | null,
): FileDescriptor[] | FileDescriptor | undefined => {
  if (!dataInstanceValue) return undefined;

  if (Array.isArray(dataInstanceValue)) {
    return dataInstanceValue.filter(Boolean).map((file: FileDescriptor) => ({
      id: file.id,
      name: file.name,
      createdBy: file.createdBy,
    }));
  }

  // если это объект
  return {
    id: dataInstanceValue.id,
    name: dataInstanceValue.name,
    createdBy: dataInstanceValue.createdBy,
  };
};
